module.exports = function(address1, city, state, zip) {
  return encodeURI("http://maps.google.com/maps?saddr=&daddr=" + address1 + "," + city + "," + state + "," + zip);
};
